exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-page {\n  text-align: center;\n  margin-top: 1.33333333rem;\n}\n.error-page img {\n  width: 6.93333333rem;\n  height: 5.6rem;\n}\n", ""]);

// exports
